var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker-goods"},[_c('SpFilterForm',{attrs:{"model":_vm.formData,"size":"small"},on:{"onSearch":_vm.onSearch,"onReset":_vm.onSearch}},[_c('SpFilterFormItem',{attrs:{"prop":"keywords"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"請輸入商品名稱"},model:{value:(_vm.formData.keywords),callback:function ($$v) {_vm.$set(_vm.formData, "keywords", $$v)},expression:"formData.keywords"}})],1),_c('SpFilterFormItem',{attrs:{"prop":"approve_status"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"請選擇"},model:{value:(_vm.formData.approve_status),callback:function ($$v) {_vm.$set(_vm.formData, "approve_status", $$v)},expression:"formData.approve_status"}},_vm._l((_vm.salesStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.title,"size":"mini","value":item.value}})}),1)],1),_c('SpFilterFormItem',{attrs:{"prop":"brand_id"}},[_c('el-select',{attrs:{"placeholder":"請選擇品牌","remote":"","filterable":"","clearable":"","remote-method":_vm.getGoodsBranchList},model:{value:(_vm.formData.brand_id),callback:function ($$v) {_vm.$set(_vm.formData, "brand_id", $$v)},expression:"formData.brand_id"}},_vm._l((_vm.goodsBranchList),function(item){return _c('el-option',{key:item.attribute_id,attrs:{"label":item.attribute_name,"value":item.attribute_id}})}),1)],1),_c('SpFilterFormItem',{attrs:{"prop":"category"}},[_c('el-cascader',{attrs:{"placeholder":"請選擇分類","clearable":"","options":_vm.categoryList,"props":{ value: 'category_id', label: 'category_name', checkStrictly: true }},model:{value:(_vm.formData.category),callback:function ($$v) {_vm.$set(_vm.formData, "category", $$v)},expression:"formData.category"}})],1),(_vm.isShowFormItem('distributor_id'))?_c('SpFilterFormItem',{attrs:{"prop":"distributor_id"}},[_c('SpSelectShop',{attrs:{"clearable":"","placeholder":"請選擇店鋪"},on:{"change":_vm.onSearch},model:{value:(_vm.formData.distributor_id),callback:function ($$v) {_vm.$set(_vm.formData, "distributor_id", $$v)},expression:"formData.distributor_id"}})],1):_vm._e()],1),_c('SpFinder',{ref:"finder",attrs:{"reserve-selection":"","row-key":"item_id","other-config":{
      'max-height': 416,
      'header-cell-class-name': _vm.cellClass
    },"url":"/goods/items","show-pager-text":"已選中：${n}","fixed-row-action":true,"setting":{
      columns: [
        { name: '商品ID', key: 'item_id', width: 80 },
        {
          name: '商品名稱',
          key: 'page_name',
          render: function (h, ref) {
                var row = ref.row;

                return h('div', { class: 'item-info' }, [
              h('div', { class: 'item-image' }, [
                h('SpImage', {
                  props: {
                    src: row.pics[0],
                    width: 60,
                    height: 60
                  }
                })
              ]),
              h('div', { class: 'item-name' }, row.itemName)
            ]);
}
        },
        {
          name: '價格（NT$）',
          key: 'price',
          width: 150,
          render: function (h, ref) {
              var row = ref.row;

              return h('span', {}, row.price / 100);
}
        },
        { name: '庫存', key: 'store', width: 150 }
      ]
    },"hooks":{
      beforeSearch: _vm.beforeSearch,
      afterSearch: _vm.afterSearch
    }},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }